import { css, html } from 'lit';
import { customElement, state, query } from 'lit/decorators';
import { DepInjMixin, requires } from '../mixins/dependency';
import { UserService } from '../services/user-service';
import { QuestionsService } from '../services/questions-service';
import { commonFormStyles, commonLHCOmponentStyle } from '../styles/common-style';
import { t } from '../utils/locale';
import { InsuranceService } from '../services/insurance-service';
import { DeviceAwareComponent } from './components/device-aware-component';
import { LHOtp } from './components/lh-otp';
import { ConfigService } from '@APP/services/config-service';
import { eventBus } from '@APP/utils/event-bus';
import { Events } from '@APP/events/app-events';

type Deps = {
  userService: UserService;
  configService: ConfigService;
  insuranceService: InsuranceService;
  questionsService: QuestionsService;
};

type Step = 'phone' | 'otp';

@requires(UserService.serviceName, ConfigService.serviceName, InsuranceService.serviceName, QuestionsService.serviceName)
@customElement('lh-login-view')
export class LHWelcome extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonLHCOmponentStyle,
      commonFormStyles,
      css`
        :host([data-device="desktop"]) {
          padding: 5rem 5rem 15rem;
        display: flex;
        justify-content: space-evenly;
      }
      :host([data-device="desktop"]) #logo {
        display: inline-block;
        height: auto;
        margin: 0 auto;
      }
      #logo {
        height: 9.25rem;
        position: relative;
        top: 2rem;
      }
      .title {
        color: var(--c-font-title);
        font-size: 4rem;
      }
      .message {
        color: var(--c-bg-sec);
        padding: 0px 3.2rem;
        font-size: 2.3rem;
      }
      :host([data-device="desktop"]) .art {
        width: 95rem;
        margin: -3% -10%;
      }
      .art {
          background-attachment: scroll;
          background-image: url(./assets/login-bg.svg);
          background-repeat: no-repeat;
          background-position: right top;
          background-size: contain;
      }
      #notice {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 3rem;
        flex-grow: 0;
        background-color: var(--c-bg-sec);
        border-radius: 1rem 1rem 0 0;
        color: var(--c-text-sec);
        padding: 2rem;
        font-size: 2rem;
      }
      #notice.hide {
        display: none;
      }
      #welcome {
        box-shadow: 0px 17px 41px rgba(25, 72, 146, 0.1);
        border-radius: 10px;
        padding: 3rem;
        margin: 10% 0 0;
        width: 65rem;
        /*height: 56rem;*/
        display: flex;
        flex-direction: column;
        align-content: space-between;
        justify-content: space-evenly;
        background-color: var(--c-background-mask);
      }
      .accept-wrapper {
        display: flex;
        align-items: center;
        height: 50%;
      }
      .checkBox {
        width: 1.5rem;
        position: relative;
        vertical-align: middle;
        height: auto;
      }
      p {
        margin: 0;
      }
      .bold {
        font-weight: var(--font-weight-emphasize);
      }
      .cookie-notice {
        padding-block-end: 1rem;
      }
      .accept-span {
        color: var(--c-select);
      }
      #controls {
        flex-direction: column;
        display: flex;
        padding: 5rem 0;
        align-items: flex-start;
      }
      button.move-forward {
        font-size: 2.2rem;
        height: 6rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        background-color: var(--c-emphasize-sec);
        border: var(--c-emphasize-sec);
        cursor: pointer;
      }
      .btn-margin {
        margin-block: 3rem 0;
      }
      button.move-forward[disabled] {
        background-color: var(--btn-disabled-color);
        color: var(--c-bg-sec);
      }
      button.move-forward:hover {
        background-color: var(--c-button-hover);
        border: 2px solid var(--c-button-hover);
      }
      
      .icon-fish {
        position: relative;
        top: 0.2rem;
      }
      #input {
        border: var(--input-border-self);
        box-sizing: border-box;
        box-shadow: 0px 3px 6px rgba(25, 72, 146, 0.06);
        border-radius: 10px;
        margin: 2rem 0 1.25rem 0;
        max-width: 47.8rem;
      }
      .label {
        font-weight: 700;
        font-size: 2.5rem;
        line-height: 3rem;
        color: rgba(18, 18, 19, 0.6);
      }
      .signup{
        font-family: Satoshi;
        font-style: normal;
        font-weight: normal;
        font-size: 2rem;
        line-height: 2.5rem;
        text-decoration-line: underline;
        color: var(--c-link);
        flex: none;
        order: 2;
        flex-grow: 0;
        margin: 45px 0px;
        cursor: pointer;
      }
      *:focus-visible {
        outline: 0px dashed transparent;
      }
    `,
    ];
  };
  static get desktopStyles() {
    return [
      css`
    button.move-forward{
      max-width: 21.1rem;
    }
    .span-error {
        padding-block-start: 0;
        font-size: 2rem;
        font-weight: 400;
        color: var(--c-err);
        margin: 0 0 4rem;
      }
      .emptyerror {
        display: block;
        height: 2.75rem;
        margin: 0 0 3rem;
        padding-block-start: var(--padding-block-start);
      }
      .input-error {
        border: var(--input-border-self-error) !important;;
      }

      .wrapper {
        margin-inline-start: 7rem;
        margin-inline-end: 5rem;
      }

  `,
    ];
  };
  static get mobileStyles() {
    return [
      css`
        #welcome {
          padding: 3rem;
          margin: 10vw;
          width: 69vw;
      /*height: 50rem;*/
    }
    #input {
      font-weight: var(--input-font-weight);
    }

    div#wrapper{
        display: flex;
        justify-content: center;
    }

    `];
  };

  static get rtlStyles() {
    return [
      css`
`];
  }

  static get ltrStyles() {
    return [
      css`
  `];
  };

  @state()
    step: Step = 'phone';

  @state()
    errroMessage: string = '';

  private showErrors = false;
  private phone = this.deps.userService.store['phone.number'];

  @query('input#input')
    phoneElement!: HTMLInputElement;

  websiteLink() {
    return this.deps.configService.get('websiteUrl');
  }

  renderHeader() {
    return html`
   <div id="wrapper" >
    <a href="${this.websiteLink() || ''}" style="cursor: pointer;" target="_self">
       <lh-logo></lh-logo>
     </a>
    </div>
    `;
  }

  private subs: Function[] = [];

  connectedCallback() {
    super.connectedCallback();
    this.phone = this.deps.userService.store['phone.number'];
    this.subs.push(eventBus().on(Events.Type.LoginSuccess, () => {
      if (this.deps.userService.userType == 'customer') {
        this.deps.questionsService.welcomePopup(true);
      }
    }),
    eventBus().on(Events.Type.ChangePhoneNumber, async() => {
      this.step = 'phone';
      setTimeout(() => eventBus().emit(Events.Type.FocusOnPhoneElement, 1000));
    }),
    eventBus().on(Events.Type.FocusOnPhoneElement, async() => {
      this.phoneElement?.focus();
    }),

    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.subs.forEach(f => f());
  }

  private validate(phone: string): boolean {
    if (!phone) {
      this.errroMessage = 'ValidErrMandatory';
      return false;
    }
    if (phone.length != 10) {
      this.errroMessage = 'ValidErrInvalidPhone';
      return false;
    }
    if (phone.startsWith('0')) {
      this.errroMessage = 'ValidErrInvalidPhoneAuth';
      return false;
    }
    return true;
  }


  private handleChange(event: InputEvent) {
    if (event.data !== null && isNaN(parseInt(event.data || ''))) {
      this.phoneElement.value = this.phone;
    } else {
      this.phone = this.phoneElement.value;
    }
    this.showErrors = false;
  }


  private handleSend() {
    if (!this.phone) {
      this.errroMessage = 'ValidErrMandatory';
      this.showErrors = true;
    }

    if (this.phone.startsWith('1') && this.phone.length == 11) {
      this.phone = this.phone.slice(1);
    }

    if (this.phone.startsWith('+1') && this.phone.length == 12) {
      this.phone = this.phone.slice(2);
    }


    if (this.validate(this.phone)) {
      this.showErrors = false;
      this.step = 'otp';
      this.deps.userService.store.phone = `+1 ${this.phone}`;
      this.deps.userService.store['phone.prefix'] = '+1';
      this.deps.userService.store['phone.number'] = this.phone;
      this.deps.questionsService.model.getQuestionById('owner_phone')!.value = '+1 ' + this.phone;
      this.deps.userService.requestOtpCode(false);
    } else {
      this.showErrors = true;
    }
  }

  private handleVerify() {
    let otp: LHOtp = this.renderRoot.querySelector('lh-otp') as LHOtp;
    otp.tryOTPCode();

  }

  private handleSignup() {
    this.deps.userService.saveOtpTracking('change-to-signup', '', '');
    /** Send S_Welcome data before login to gtm */
    this.deps.userService.sendWebtrackingData('change-to-signup', '');
    this.deps.userService.changeLoginMode('signup');
  }

  renderControls() {
    if (this.step == 'phone') {
      return html`
        <button
          primary
          pop
          @click=${this.handleSend}
          class="move-forward"
        >
          <span class="">${t('T_Send')}</span>
        </button>
        <div class="signup">
        <a link pop @click=${this.handleSignup}
          >${t('T_Signup_Link')}</a
        >
      </div>
      `;
    } else {
      return html`
        <button
          primary
          pop
          @click=${this.handleVerify}
          class="move-forward btn-margin"
        >
          <span class="">${t('T_Verify')}</span>
        </button>
      `;

    }
  }

  renderInput() {
    if (this.step == 'phone') {
      return html`
      <h1 class="title">Sign in</h1>
      <span class="label">Phone number</span>
        <input
        class=${this.showErrors ? 'input-error' : ''}
        id="input"
        type="tel"
        inputmode="numeric"
        value=${this.phone}
        placeholder="(000) 000-00000"
        @input=${(e: InputEvent) =>
    this.handleChange(e)}
      />
      ${this.showErrors ? html`<span class="span-error">${t(this.errroMessage)}</span>` : html`<span class="emptyerror"></span>`}
    `;
    } else {
      return html`
        <lh-otp .isLogin=${true}></lh-otp>
    `;

    }
  }

  renderContent() {
    return html`
      ${this.renderHeader()}
      <div id="welcome">
      <div id="controls">
        ${this.renderInput()}
        ${this.renderControls()}
      </div>
    </div>
    `;
  }
}